/** 用来在内存保存一些数据的工具模块*/
const Memory = {
  user: {},
};
export default Memory;
